import { render } from "./MyOrganization.vue?vue&type=template&id=8c7091b8"
import script from "./MyOrganization.vue?vue&type=script&lang=js"
export * from "./MyOrganization.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/ddv-home/MyOrganization.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8c7091b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8c7091b8', __exports__)) {
    api.reload('8c7091b8', __exports__)
  }
  
  module.hot.accept("./MyOrganization.vue?vue&type=template&id=8c7091b8", () => {
    api.rerender('8c7091b8', render)
  })

}


export default __exports__